<script>
  import { onMount, onDestroy } from 'svelte';

  // Svelte 5 Props 接收
  let { 
    onVerify = (token) => {}, 
    siteKey = "0x4AAAAAAER27fF0BZK_20iO",
    enabled = true 
  } = $props();

  let container = $state(null);
  let widgetId = $state(null);

  onMount(() => {
    // 🌟 未开启时直接返回，不加载 CF 脚本
    if (!enabled) return;

    if (!window.turnstile) {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = () => renderWidget();
    } else {
      renderWidget();
    }
  });

  function renderWidget() {
    if (window.turnstile && container) {
      widgetId = window.turnstile.render(container, {
        sitekey: siteKey,
        callback: (token) => onVerify(token),
      });
    }
  }

  onDestroy(() => {
    if (window.turnstile && widgetId !== null) {
      window.turnstile.remove(widgetId);
    }
  });
</script>

{#if enabled}
  <div bind:this={container} class="my-4"></div>
{/if}